<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     接入点列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ap-list padding-footer mb-md">
    <div class="filter-container">
       <div class="filter-box">
        <div class="filter-item mb-md">
          <f-radio-btn-group v-model="query.status" :groups="status" @change="fetchData(1)" />
        </div>
        <span class="filter-item mb-md">
          <f-date-picker v-model="query.expire_day" :shortcuts="[0, 'end', 'lastMonthEnd']" clearable placeholder="有效期至" style="width: 160px" @change="fetchData(1)" />
        </span>
        <span class="filter-item mb-md" style="width: 200px;">
          <el-input v-model="query.keyword" clearable placeholder="接入点编号 / 绑定设备" prefix-icon="el-icon-search" @change="fetchData(1)" />
        </span>

        <div v-show="allFilterShow" class="filter-item mb-md">
          <el-select v-model="query.ap_productid" placeholder="套餐类型" style="width: 160px" @change="fetchData(1)" clearable filterable>
            <el-option v-for="item in package_type" :key="item.productid" :label="item.model" :value="item.productid" />
          </el-select>
        </div>
        <span v-show="allFilterShow" class="filter-item mb-md" style="width: 160px">
          <el-select v-model="query.dss_days" placeholder="数据存储" style="width: 100%" clearable filterable @change="fetchData(1)">
            <el-option v-for="item in dss_options" :key="item.days" :label=" item.days ? '保留' + item.days + '天' : '系统默认'" :value="item.days" />
          </el-select>
        </span>
        <span v-show="allFilterShow" class="filter-item mb-md" style="width: 160px">
          <el-select v-model="query.pro_version" placeholder="高级功能" style="width: 100%" clearable filterable @change="fetchData(1)">
            <el-option v-for="item in pro_version" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </span>
        <div v-show="allFilterShow" class="filter-item mb-md">
          <el-select v-model="query.is_registered" placeholder="备案状态" style="width: 160px" @change="fetchData(1)" clearable filterable>
            <el-option v-for="item in filing_status" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>

        <el-button
          v-if="!allFilterShow"
          icon="el-icon-more"
          :type="query.ap_productid || query.dss_days || query.is_registered ? 'primary' : 'default'"
          circle
          class="circle-btn filter-item mb-md"
          @click="showAllFilter(1)"
        />

        <div v-show="allFilterShow" class="filter-item mb-md" style="width: 160px">
          <f-dev-selector v-model="query.devid" :show-not-load="true" placeholder="选择模型" width="160" @change="fetchData(1)" />
        </div>
        <span v-show="allFilterShow" class="filter-item mb-md" style="width: 160px">
          <el-select v-model="query.precharge_month" placeholder="预充时长" clearable @change="fetchData(1)">
            <el-option v-for="(item,index) in selectOptions" :key="index" :label="item.label" :value="item.precharge_month" />
          </el-select>
        </span>
        <div v-show="allFilterShow" class="filter-item mb-md">
          <f-date-range-picker
            :shortcuts="[0, -7, 'this-month', 'last-month', 'last-last-month']"
            v-model="deliverytime"
            splaceholder="移交开始日期"
            eplaceholder="移交结束日期"
            style="width: 260px;"
          />
        </div>
        <el-button
          v-show="allFilterShow"
          icon="el-icon-arrow-left"
          circle
          class="filter-item circle-btn mb-md"
          @click="showAllFilter(0)"
        />
      </div>

      <div class="toolbox mb-md">
        <div v-if="ap_quota_enable && ap_quota_remain > 0" role="button" style="height: 36px;line-height: 36px;padding: 0 5px;" @click="toQuotaManage">
          <span>剩余配额</span>
          <span class="ml-sm" :class="{ 'text-success': ap_quota_remain > 0, 'text-danger': ap_quota_remain == 0 }">{{ ap_quota_remain }}</span>
        </div>
        <el-button v-if="ap_quota_enable && ap_quota_remain > 0" type="success" @click="createAp" class="ml-sm">新建接入点</el-button>
        <f-sort-selector v-model="query.sort" :options="sortOptions" width="80" @change="fetchData(1)" class="ml-sm" />
      </div>
    </div>

    <el-card v-loading="loading" shadow="never" style="margin-top: -20px;">
      <el-table
        ref="listTable"
        :data="list"
        tooltip-effect="dark"
        class="padding-small"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />

        <el-table-column label="设备/接入点编号" :show-overflow-tooltip="true" min-width="180">
          <template slot-scope="scope">
            <div class="ap-name-cell">
              <f-equip-name :equip="{ equipid: scope.row.sim_equipid, equip_name: scope.row.equip_name }" />
              <el-link class="ap-simid" :underline="false" @click="toApDialog(scope.row)">{{ scope.row.simid }}</el-link>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="套餐类型" :show-overflow-tooltip="true" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.ap_model }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态/通讯时间" min-width="130">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="hd mr-sm font-lg">
                <i v-if="scope.row.is_online === 1" class="iconfont icon-circle-outline text-success"></i>
                <i v-else class="text-muted iconfont icon-circle-fill" />
              </div>
              <div class="bd" style="line-height: 16px">
                <div>{{ scope.row.is_online ? '在线' : '离线' }}</div>
                <div class="font-sm text-muted">{{ scope.row.last_upload_time * 1000 | parseTime('{y}/{m}/{d} {h}:{i}') }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="流量监控" :show-overflow-tooltip="true" min-width="180">
          <template slot-scope="scope" v-if="scope.row.ap_type != 'nosim' && scope.row.first_activation">
            <div class="flex justify-content-space-between text-muted" style="font-size: 10px">
              <div>
                已用
                <span :class="scope.row.period_flow_used < scope.row.flow_total ? 'text-warning' : 'text-danger'">{{ Number.isInteger(scope.row.period_flow_used) ? scope.row.period_flow_used + 'M' : scope.row.period_flow_used.toFixed(2) + 'M' }}</span>
              </div>
              <div>{{ '剩余' + (Number.isInteger(scope.row.flow_total - scope.row.period_flow_used) ? (scope.row.flow_total - scope.row.period_flow_used) : (scope.row.flow_total - scope.row.period_flow_used).toFixed(2)) + 'M/共' + scope.row.flow_total + 'M' }}</div>
            </div>
            <el-progress
              :show-text="false"
              :percentage="scope.row.period_flow_used / scope.row.flow_total * 100 > 100 ? 100 : scope.row.period_flow_used / scope.row.flow_total * 100"
              :stroke-width="6"
              :status="scope.row.period_flow_used >= scope.row.flow_total ? 'exception' : 'success'"
              class="data-progress"></el-progress>
          </template>
        </el-table-column>

        <el-table-column min-width="140">
          <template slot="header" slot-scope="scope">
            <div class="flex align-items-center">
              <span class="mr-xs">激活时间</span>
              <el-tooltip placement="top">
                <span slot="content">
                  接入点激活方式：1、超沉默期强制激活；2、上电自动激活。
                  <br />若是生产阶段通电测试，可申请恢复沉默，注意通电测试切忌时间过长。
                </span>
                <i class="iconfont icon-circle-question" style="font-size: 14px;color: #909399;"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <span v-if="scope.row.first_activation == 0">
                沉默至{{ scope.row.silent_deadline | parseTime('{y}/{m}/{d}') }}
                <el-tooltip placement="top" v-if="scope.row.silent_recover_time">
                  <span slot="content">
                    接入点已于{{ scope.row.silent_recover_time | parseTime('{y}年{m}月{d}日') }}完成通电测试
                  </span>
                  <i v-if="scope.row.silent_recover_time" class="iconfont icon-tested text-primary"></i>
                </el-tooltip>
              </span>
              <span v-else class="flex align-items-center">
                <span>{{ scope.row.first_activation | parseTime('{y}/{m}/{d}') }}</span>
                <el-tooltip v-if="scope.row.silent_status" placement="top">
                  <span slot="content">
                    恢复沉默
                  </span>
                  <i v-if="scope.row.silent_status" class="iconfont icon-restore-silence silence ml-xs" style="font-size: 18px;" @click="toSilence(scope.row)"></i>
                </el-tooltip>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="有效日期" min-width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.first_activation == 0" class="flex align-items-center text-success">{{ scope.row.precharge_month }}</div>
            <div v-else-if="!scope.row.expire_day" class="flex align-items-center">{{ '长期' }}</div>
            <div v-else class="flex align-items-center">
              <span :class="{ 'text-danger': scope.row.ap_expired }">{{ scope.row.expire_day | parseTime('{y}/{m}/{d}') }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="高级功能" :show-overflow-tooltip="true" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.pro_version === 1" type="success">已开通</el-tag>
            <el-tag v-else type="info">未开通</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="数据存储" :show-overflow-tooltip="true" min-width="100">
          <template slot-scope="scope">{{ scope.row.dss_days <= 7 ? '系统默认' : `保留${scope.row.dss_days}天` }}</template>
        </el-table-column>

        <el-table-column label="关联" min-width="80" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.dtuid" placement="top">
              <div slot="content">
                <div>终端型号：{{scope.row.dtu_model}}</div>
                <div v-if="scope.row.mac">MAC地址：{{scope.row.mac}}</div>
              </div>
              <el-link :underline="false">
                <i class="iconfont icon-dtu font-2x middle text-muted" style="font-size:24px" />
              </el-link>
            </el-tooltip>
            <el-tooltip v-if="scope.row.iccid" :content="'ICCID： ' + scope.row.iccid" placement="top">
              <el-link :underline="false">
                <i class="iconfont icon-Ap font-2x middle text-muted" style="font-size:24px" />
              </el-link>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="110" class-name="operate-column">
          <template slot-scope="scope">
            <el-button type="text" class="mr" @click="toApDialog(scope.row)">查看</el-button>

            <el-popover placement="right" trigger="hover">
              <div v-if="scope.row.cart_num > 0" class="text-center">
                从充值购物车中
                <el-link type="primary" class="font-sm" @click="removeOne(scope.row)">移除</el-link>
              </div>
              <div v-else class="text-center">加入充值购物车</div>
              <el-badge slot="reference" :value="scope.row.cart_num" :hidden="scope.row.cart_num <= 0">
                <span class="font-2x text-success cursor-pointer" @click="addOne(scope.row)">
                  <i class="iconfont icon-shapping-cart" style="font-size:24px" />
                </span>
              </el-badge>
            </el-popover>
          </template>
        </el-table-column>

        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
          <el-button type="warning" plain size="small" @click="apDOC">了解接入点</el-button>
        </div>
      </el-table>
    </el-card>
    <div class="foot" :class="!collapse && 'active'">
      <f-table-footer :list="list" :selection="multiSelection" @toggle="toggleAll" checkbox>
        <el-button type="success" size="mini" :disabled="multiSelection.length === 0" :plain="multiSelection.length === 0" @click="addMulti">加入充值购物车</el-button>
        <el-button type="success" size="mini" plain @click="recoverSilence()">恢复沉默</el-button>
        <el-button type="success" size="mini" plain @click="forRecord()">DTU备案</el-button>
        <el-button type="success" size="mini" plain @click="recycle_bin = true">回收站</el-button>
        <el-button size="mini" type="success" plain @click="exportAp" :disabled="is_disable">导出</el-button>
        <template slot="right">
          <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
        </template>
      </f-table-footer>
    </div>


    <ap-recycle-bin v-if="recycle_bin" :show.sync="recycle_bin" />
    <ap-for-record v-if="apRecord" :show.sync="apRecord" @change="fetchData"/>
    <ap-create v-if="apCreateShow" :show.sync="apCreateShow" :month="precharge_month" @success="handleSuccess"/>
    <quota-manage v-if="quotaManageShow" :show.sync="quotaManageShow" @change="fetchQuota" @create="toCreate" />
    <ap-recover-silence v-if="apRecoverSilenceShow" :show.sync="apRecoverSilenceShow" :silence-list="silence_list"  @change="fetchData" @close="handleClose" @share="openShare" />
    <rms-equip-share ref="equipShare" :show.sync="equipShareShow" :equips="shareEquips" />
  </div>
</template>

<script>
import { apApListApi, apGetModelApi, apExportApi, getQuotaApi } from "@/api/ap/apApi";
import { apCartPostApi, apCartDeleteApi,dssOptionsApi } from "@/api/ap/apRechargeApi";
import { parseTime } from "@/utils/common";
import ApRecoverSilence from "./components/ApRecoverSilence.vue";

export default {
  components: {
    ApRecycleBin: () => import("./components/ApRecycleBin"),
    ApDatePicker: () => import("./components/ApDatePicker"),
    ApDetailCurve: () => import("./components/ApDetailCurve"),
    ApDtuSingal: () => import("./components/ApDtuSingal"),
    ApForRecord: () => import("./components/ApForRecord"),
    QuotaManage: () => import("./components/QuotaManage.vue"),
    ApCreate: () => import("./components/ApCreate"),
    ApRecoverSilence,
    RmsEquipShare: () => import("../rms/components/RmsEquipShare"),
  },

  data() {
    return {
      // eslint-disable-next-line
      recycle_bin: this.$route.query.recycle_bin ? true : false,
      status: [
        { value: -1, title: "全部", separate: true },
        { value: 3, title: "在线" },
        { value: 2, title: "离线" },
        { value: 1, title: "未激活" },
        { value: 4, title: "待续费" }
      ],
      query: {
        keyword: "",
        pindex: 1,
        sort: null,
        status: this.$route.query.status ? this.$route.query.status : -1,
        expire_day: this.$route.query.expire_day
          ? Number(this.$route.query.expire_day)
          : null,
        psize: this.$store.state.commonStore.psize,
        ap_productid: null,
        devid: null,
        precharge_month: null,
      },
      loading: false,
      is_disable: false,
      total: 0,
      list: [],
      multiSelection: [],
      sortOptions: [
        { value: 0, title: "最近创建" },
        { value: 4, title: "最近激活" },
        { value: 10, title: "最早到期" },
        { value: 9, title: "最晚到期" },
      ],

      package_type: [],
      filing_status: [
        { value: 0, title: "未备案" },
        { value: 1, title: "已备案" },
      ],

      apDeatil: false,
      simid: 0,
      apRecord: false,
      dss_options: [],
      allFilterShow: Number(localStorage.getItem(`__FILTER_ALL_SHOW_APLIST__`)),
      quotaManageShow: false,
      ap_quota_remain: 0,
      apCreateShow: false,

      precharge_month: 0,

      apRecoverSilenceShow: false,
      silence_list: [],

      selectOptions: [
        {
          precharge_month: 12,
          label: "1年",
        },
        {
          precharge_month: 24,
          label: "2年",
        },
        {
          precharge_month: 36,
          label: "3年",
        },
        {
          precharge_month: 48,
          label: "4年",
        },
        {
          precharge_month: 60,
          label: "5年",
        },
        {
          precharge_month: 72,
          label: "6年",
        },
      ],
      deliverytime: [],
      equipShareShow: false,
      shareEquips: [],
      pro_version: [
        { value: 0, title: "未开通" },
        { value: 1, title: "已开通" },
      ],
    };
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
    cart() {
      return this.$store.state.memberStore.cart;
    },
    ap_quota_enable() {
      return this.$store.state.godStore.ap_quota_enable;
    }
  },

  watch: {
    cart(nval) {
      if (nval) this.fetchData(null, false);
    },
    deliverytime(val) {
      if (!this.deliverytime) {
        this.query.delivery_starttime = null;
        this.query.delivery_endtime = null;
        this.fetchData(1);
      }
      if (this.deliverytime && this.deliverytime.length > 0) {
        this.query.delivery_starttime = this.deliverytime[0];
        this.query.delivery_endtime = this.deliverytime[1];
        this.fetchData(1);
      }
    },
  },

  created() {
    const keepAlivePath = ["/ap/detail", "/rms/equip/detail"];
    this.query = this.$utils.initListQuery(this.query, keepAlivePath);
    this.fetchData();
    this.fetchModel();
    this.fetchDssOptions()
    this.fetchQuota();
    const openQuota = sessionStorage.getItem("__OPEN_QUOTA__");
    if (openQuota) {
      this.quotaManageShow = true;
      sessionStorage.removeItem("__OPEN_QUOTA__");
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query);
    next();
  },

  methods: {
    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },
    fetchData(page, loading = true) {
      if (page) this.query.pindex = page;
      if (loading) this.loading = true;
      apApListApi(this.query).then(res => {
        this.loading = false;
        if (res.errno === 0) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchModel() {
      apGetModelApi().then(res => {
        if (!res.errno) {
          this.package_type = res.data.list;
        }
      });
    },

    fetchDssOptions() {
      dssOptionsApi().then(res => {
        if (!res.errno) {
          this.dss_options = res.data;
        }else {
          this.$message.error(res.message);
        }
      });
    },

    fetchQuota() {
      getQuotaApi().then((res) => {
        if (!res.errno) {
          this.ap_quota_remain = res.data.ap_quota_remain;
        }
      });
    },

    handleSuccess() {
      this.fetchData();
      this.fetchQuota();
    },

    showAllFilter(val) {
      this.allFilterShow = val
      localStorage.setItem(`__FILTER_ALL_SHOW_APLIST__`, val)
    },

    toQuotaManage() {
      this.quotaManageShow = true;
    },

    createAp() {
      if (this.$store.state.godStore.certified !== 1) {
        this.$fCertifiedConfirm({
          onConfirm: () => {
            this.$router.push("/fam/certify")
          }
        })
        return
      }
      if(this.ap_quota_remain == 0) {
        this.quotaManageShow = true;
        return;
      }
      this.precharge_month = 12
      this.apCreateShow = true;
    },

    toCreate(e) {
      this.precharge_month = e
      this.apCreateShow = true
    },

    toApDialog(row) {
      this.simid = row.simid;
      this.$detail({ type: "ap", id: row.simid });
    },

    selectable(row) {
      return row.first_activation > 0;
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
      this.silence_list = val.filter(v => v.silent_status);
    },

    addOne(row) {
      const tempData = {
        simid: row.simid,
        num: 1,
        productid: row.productid
      };
      apCartPostApi({ data: [tempData] }).then(res => {
        if (res.errno === 0) {
          this.fetchData(null, false);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    addMulti() {
      this.$confirm(
        `将选中的 <span class="font-lg text-success">${
          this.multiSelection.length
        }</span> 个接入点全部添加至充值购物车, 是否继续?`,
        "提示",
        {
          type: "success",
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          const tempData = [];
          for (const v of this.multiSelection) {
            tempData.push({
              simid: v.simid,
              num: 1,
              productid: v.productid
            });
          }
          this.loading = true;
          apCartPostApi({ data: tempData }).then(res => {
            if (res.errno === 0) {
              this.fetchData(null, true);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    handleClose() {
      this.silence_list = this.multiSelection.filter(v => v.silent_status);
    },

    openShare(e) {
      this.shareEquips = e;
      this.equipShareShow = true;
    },

    forRecord() { // DTU备案
      this.apRecord = true
    },

    removeOne(row) {
      apCartDeleteApi({ cartids: row.cartids }).then(res => {
        if (res.errno === 0) {
          this.fetchData(null, false);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    apDOC() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/33");
    },

    exportAp() {
      this.is_disable = true;
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      apExportApi({ ...this.query }).then(res => {
        loading.close();
        this.is_disable = false;
        const blob = new Blob([res], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        const elink = document.createElement("a");
        elink.download =
          "接入点记录导出" +
          parseTime(+new Date(), "{y}{m}{d}{h}{i}{s}") +
          ".xlsx";
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      });
    },

    toSilence(row) {
      this.apRecoverSilenceShow = true;
      this.silence_list = [row];
    },
    recoverSilence() {
      this.apRecoverSilenceShow = true;
    },
  }
};
</script>

<style lang="scss" scoped>
.ap-list {
  .ap-name-cell {
    line-height: 18px;

    .ap-simid {
      &.el-link {
        color: #909399;
        font-size: 12px;

        &:hover {
          color: #07c160;
        }
      }
    }
  }

  .silence {
    cursor: pointer;
    color: #909399;
    &:hover {
      color: #07c160;

    }
  }
  /deep/ .operate-column {
    .cell {
      display: flex;
      align-items: center;
      line-height: 36px;
      overflow: visible;
      .el-badge__content.is-fixed {
        top: 10px;
      }

      &>span {
        display: block;

        .el-popover__reference-wrapper {
          display: block;

          .el-badge > span {
            display: block;
          }
        }
      }
    }
  }
}
.foot {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 240px;
  z-index: 3;
  width: calc(100% - 240px);
  padding-left: 38px;
  &.active {
    left: 340px;
    width: calc(100% - 340px);
  }
}
.package-title {
  width: 200px;
  height: 40px;
  line-height: 40px;
  color: rgba(48, 49, 51, 1);
  font-size: 16px;
  text-align: left;
  margin-bottom: 20px;
}
</style>
<style lang="scss">
.el-progress.data-progress {
  .el-progress-bar__outer {
    border-radius: 5px;
    background-color: #DCDFE6;
  }

  .el-progress-bar__inner {
    border-radius: 5px;
  }
}
</style>
